/* eslint-disable @angular-eslint/no-output-on-prefix */

import {
  booleanAttribute,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  output,
} from '@angular/core';
import {
  FormControl,
  ReactiveFormsModule,
  ValidationErrors,
} from '@angular/forms';

import { MatInputModule } from '@angular/material/input';
import {
  FloatLabelType,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { TextFieldModule } from '@angular/cdk/text-field';

import { CanAutoFocusDirective } from './directives';
import { DEFAULT_ERROR_STATE_MATCHER_PROVIDER } from './providers';

import { ErrorMessagePipe } from '@shared/pipes';
import { ControlValueAccessorDirective } from '@shared/directives';

@Component({
  selector: 'app-ccs-textarea',
  imports: [
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    ErrorMessagePipe,
    TextFieldModule,
    CanAutoFocusDirective,
  ],
  templateUrl: './ccs-textarea.component.html',
  hostDirectives: [ControlValueAccessorDirective],
  providers: [DEFAULT_ERROR_STATE_MATCHER_PROVIDER],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CcsTextareaComponent<T> {
  @Input({ required: true }) label = '';
  @Input({ required: false }) placeholder = '';
  @Input({ required: false }) hint = '';
  @Input({ required: false }) maxLength!: number;
  @Input({ required: false }) autosizeMinRow = 5;
  @Input({ required: false }) autosizeMaxRow = 5;
  @Input({ required: false }) floatLabel: FloatLabelType = 'always';
  @Input({ required: false }) errorMessages: ValidationErrors | null = null;
  @Input({ required: false, transform: booleanAttribute }) autofocus = false;

  private readonly _va = inject(ControlValueAccessorDirective);
  public readonly cdr = inject(ChangeDetectorRef);

  public onFocus = output<FocusEvent>();
  public onBlur = output<FocusEvent>();
  public onKeydown = output<KeyboardEvent>();
  public onKeyup = output<KeyboardEvent>();
  public onInput = output<InputEvent>();

  get control(): FormControl<T | null> {
    return this._va.control;
  }
}
